import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FileDetailsState } from './file-details.state';

export const selectFileDetailsState =
  createFeatureSelector<FileDetailsState>('fileDetails');

export const selectFile = createSelector(
  selectFileDetailsState,
  state => state.file
);

export const selectStatuses = createSelector(
  selectFileDetailsState,
  state => state.statuses
);

export const selectIsLoading = createSelector(
  selectFileDetailsState,
  state => state.isLoading
);

export const selectIsUpdating = createSelector(
  selectFileDetailsState,
  state => state.isUpdating
);

export const selectIsLoadingStatuses = createSelector(
  selectFileDetailsState,
  state => state.isLoadingStatuses
);

export const selectError = createSelector(
  selectFileDetailsState,
  state => state.error
);
